import { useTranslation } from "react-i18next";
import './PrivacyPolicy.css';
import Footer from "../../components/Footer/Footer"; // Import the Footer component

export const PrivacyPolicy = () => {
    const { t } = useTranslation();

    const terms = t('privacyPolicy.content', { returnObjects: true });

    return (
        <div className="privacy-policy-page">
            <div className="privacy-policy-container">
                <h1 className="privacy-policy-header">{t('privacyPolicy.header')}</h1>
                <p className={"privacy-policy-desc"}>{t('privacyPolicy.description')}</p>
                {terms.map((term, index) => (
                    <div key={index} className="privacy-policy-term">
                        <h2 className="privacy-policy-term-label">{term.label}</h2>
                        <p className="privacy-policy-term-desc">{term.desc}</p>
                    </div>
                ))}
            </div>
            <Footer />
        </div>
    );
}
